import Offers from "./Offers";

export { getOffers } from './Offers';
export default Offers
